/* eslint-disable */
import bi1_data_validation from '../../base_i1_datavalidation'
import { RC, CR } from '../../base_i2_success_codes'
import base_i3_log from '../../base_i3_logging'
import { ajax } from 'noquery-ajax'

function generateControlProcessorToken(cp_uid) {
  return new Promise(function (resolve, reject) {
    let debug_data = [];
    const task_id = 'p1s2t4_generateControlProcessorToken';
    let return_msg = '';

    ///// input validation
    let call_result = bi1_data_validation.is_string(cp_uid);
    debug_data.push(call_result);
 
    let validation_failed_flag = false;
    for (let index in debug_data) {
      if (debug_data[index][CR.success] !== RC.success) {
        validation_failed_flag = true;
        break;
      }
    }

    if (validation_failed_flag === true) {
      return_msg += 'input validation failed';
      base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
      reject({ success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data });
      return;
    }
    /////</end> input validation

    ajax({
      url: `${window.G_p1s6_tasks_domain}/p1s2t4-generate-control-token`,
      method: 'POST',
      dataType: 'JSON',
      data: {
        'p1s2t4-cp_uid': cp_uid
      },
      success: function (result) {
        resolve({ success: RC.success, return_msg: return_msg, debug_data: debug_data});
      },
      error: function (result) {
        return_msg += 'failed to generate control token, error data: ' + JSON.stringify(result);
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.ajax_failure, return_msg, debug_data);
        reject({ success: RC.general_failure, return_msg: return_msg, debug_data: debug_data});
      }
    })
  });
};

export default generateControlProcessorToken


// WEBPACK FOOTER //
// ./src/watchdog_includes/json_tasks/p1s2/p1s2t4.js